/** Catégorie d'un lieu proposé au client (liste illustrée sur borne et mobile). */
export enum PlaceType {
	AIRPORT = 'AIRPORT',
	HELIPORT = 'HELIPORT',
	HOTEL = 'HOTEL',
	TRAIN_STATION = 'TRAIN_STATION',
	PORT = 'PORT',
	CASINO = 'CASINO',
	AGENCY = 'AGENCY',
	LANDMARK = 'LANDMARK',
	TAXI_RANK = 'TAXI_RANK',
	OTHER = 'OTHER',
}

/**
 * Mode d'affichage de l'application.
 *
 * Déterminé au démarrage : `KIOSK` si la borne est provisionnée (token machine ou
 * `?mode=kiosk`), `DRIVER` si l'utilisateur connecté possède `DRIVER_MODE`,
 * `CLIENT` sinon. L'utilisateur DRIVER peut basculer manuellement en CLIENT.
 */
export enum AppMode {
	CLIENT = 'CLIENT',
	DRIVER = 'DRIVER',
	KIOSK = 'KIOSK',
}

/** Catégorie de véhicule — influe sur la capacité et le filtrage du dispatch. */
export enum VehicleCategory {
	BERLINE = 'BERLINE',
	VAN = 'VAN',
	GREEN = 'GREEN',
	LUXURY = 'LUXURY',
}

/** Canaux de notification supportés. */
export enum NotificationChannel {
	REALTIME = 'REALTIME',
	PUSH = 'PUSH',
	SMS = 'SMS',
	EMAIL = 'EMAIL',
}

export enum NotificationType {
	RIDE_OFFER = 'RIDE_OFFER',
	RIDE_ACCEPTED = 'RIDE_ACCEPTED',
	RIDE_DRIVER_ARRIVED = 'RIDE_DRIVER_ARRIVED',
	RIDE_IN_PROGRESS = 'RIDE_IN_PROGRESS',
	RIDE_COMPLETED = 'RIDE_COMPLETED',
	RIDE_CANCELLED = 'RIDE_CANCELLED',
	RIDE_NO_DRIVER = 'RIDE_NO_DRIVER',
	SYSTEM = 'SYSTEM',
}

/** Langues supportées (borne : sélecteur FR/EN visible en pied d'écran). */
export const SUPPORTED_LOCALES = ['fr', 'en', 'it'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = 'fr';
